import styled from 'styled-components';
import { PopoverContent, MenuList, MenuButton, theme } from '@frameio/vapor';
import LinkButton from './LinkButton';
export var DropdownButton = styled(LinkButton).withConfig({
  displayName: "Dropdown__DropdownButton",
  componentId: "@frameio/developer-components__sc-d07pgv-0"
})({
  svg: {
    transition: 'transform 0.3s ease'
  },
  '&[aria-expanded="true"] svg': {
    transform: 'rotateZ(180deg)'
  }
});
export var DropdownMenu = styled(MenuList).withConfig({
  displayName: "Dropdown__DropdownMenu",
  componentId: "@frameio/developer-components__sc-d07pgv-1"
})({
  padding: '8px 0 !important',
  minWidth: '120px !important',
  display: 'inline-block',
  a: {
    width: '100%',
    textDecoration: 'none',
    color: '#666a72'
  }
});
export var DropdownMenuButton = styled(MenuButton).withConfig({
  displayName: "Dropdown__DropdownMenuButton",
  componentId: "@frameio/developer-components__sc-d07pgv-2"
})({
  display: 'inline-flex',
  padding: '0 0 0 4px !important',
  width: '120px',
  ':active:before, :before': {
    backgroundColor: "".concat(theme.colors.palette.brandPrimary, " !important")
  },
  '&[data-selected="true"]': {
    a: {
      color: "".concat(theme.colors.palette.brandPrimary, " !important")
    }
  },
  a: {
    display: 'inline-block',
    textDecoration: 'none',
    color: '#666a72'
  },
  span: {
    textDecoration: 'none !important',
    color: '#666a72'
  },
  ':hover': {
    span: {
      color: "".concat(theme.colors.palette.whiteA100, " !important")
    }
  }
});
export var StyledPopoverContent = styled(PopoverContent).withConfig({
  displayName: "Dropdown__StyledPopoverContent",
  componentId: "@frameio/developer-components__sc-d07pgv-3"
})({
  zIndex: theme.zIndices.popover,
  background: '#fff !important',
  borderRadius: '4px !important',
  boxShadow: "\n    0 0 0 1px rgba(136,152,170,0.1),\n    0 15px 35px 0 rgba(49,49,93,0.1), \n    0 5px 15px 0 rgba(0,0,0,0.08) !important\n  "
});